export const isStepValueEmpty = (value: unknown): boolean => {
	if (value === null || value === undefined) {
		return true;
	}

	if (typeof value === "string") {
		return value.trim() === "";
	}

	if (value instanceof Date) {
		return Number.isNaN(value.getTime());
	}

	if (Array.isArray(value)) {
		return value.every(item => isStepValueEmpty(item));
	}

	if (typeof value === "object") {
		const objectValues = Object.values(value as Record<string, unknown>);
		return objectValues.every(item => isStepValueEmpty(item));
	}

	return false;
};
